import { Component, OnDestroy, OnInit } from '@angular/core';
import { ContactInformation } from './contact-us.types';
import { combineLatest, Subscription } from 'rxjs';
import { ContactInfo } from '../../services/theme/theme.types';
import { ThemeService } from '../../services/theme/theme.service';
@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
})
export class ContactUsComponent implements OnInit, OnDestroy {
  currentAssets: { registration: ContactInfo[] } | null = null;
  _contacts: ContactInformation[] = [];
  private subscription: Subscription = new Subscription();
  constructor(private themeService: ThemeService) {}

  mailto(email: string) {
    return `mailto:${email}?subject="Contact Us"`;
  }

  formatContacts(registration: ContactInfo[]): ContactInformation[] {
    return registration
      // Show any country that has at least one usable contact detail. Filtering
      // strictly on quote_phone hid entries that only carry claim contact info or
      // emails (attribute keys are configured per country), leaving the popup blank
      // even though the data was present.
      .filter(
        (contact) =>
          contact.quote_phone ||
          contact.quote_and_registration_email ||
          contact.claim_phone ||
          contact.claim_email
      )
      .map((contact) => {
        return {
          title: contact.country_name,
          flag_source: contact.country_flag,
          subtitle: undefined,
          registration: {
            message: 'Quote and Registration Support',
            phone: contact.quote_phone,
            email: contact.quote_and_registration_email,
          },
          claim: {
            message: 'Claim Support',
            phone: contact.claim_phone,
            email: contact.claim_email,
          },
        };
      });
  }

  public get contacts(): ContactInformation[] {
    return this._contacts;
  }

  ngOnInit(): void {
    // React to both load state and the country assets stream so the popup renders
    // whenever the data becomes available — including data restored from the theme
    // cache after this component initialises. Reading it only once (gated on
    // isLoaded) raced with async theme application and left the popup blank in some
    // browsers/locations even though the data was present.
    this.subscription = combineLatest([
      this.themeService.isLoaded$,
      this.themeService.countryAssets$,
    ]).subscribe(([isLoaded, assets]) => {
      if (!isLoaded) {
        return;
      }
      this.currentAssets = assets;
      const contacts = assets?.registration;
      this._contacts = contacts && contacts.length ? this.formatContacts(contacts) : [];
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
